import React from 'react';
import {withRouter} from 'react-router-dom';
import {useSelector} from 'react-redux';
import './index.scss';

import * as Routes from '../../../constants/routes';

//assets
import logo from 'assets/logos/hot-new.svg';

const FallbackUI = () =>{

    const text = useSelector(store => store.config.Translations);

    const btnOnClick = () =>{
        window.location.href = Routes.home;
    };

    return(
        <section className='fallback-ui'>
            <img className='logo' src={logo} alt='logo'/>
            <h3>{text['fallback_ui_msg']}</h3>
            <button className='refresh-btn' onClick={btnOnClick}>{text['fallback_ui_btn']}</button>
        </section>
    );
};

export default withRouter(FallbackUI);